import { MetaFieldType, } from '@synisys/idm-kb-service-client-js';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { first, map, mapTo, switchMap } from 'rxjs/operators';
import { MetaFormModel } from '../model/meta-form.model';
/**
 * @author Vahagn Lazyan.
 * @since 2.5.2
 */
export function loadEntityWithNameFieldsOnly(kbService, deService, categoryName, entityId) {
    return kbService.getNameMetaFieldIds(categoryName).pipe(switchMap(function (metaFields) {
        return deService.loadEntityByInstanceId(categoryName, entityId, true, metaFields.map(function (f) { return f.getSystemName(); }));
    }));
}
export function checkEntityExists(kbService, deService, categoryName, entityId) {
    return kbService
        .getMetaFields(categoryName)
        .pipe(switchMap(function (metaFields) {
        return deService
            .loadEntityByInstanceId(categoryName, entityId, false, [
            metaFields
                .find(function (f) {
                return f.getType() ===
                    MetaFieldType.INTEGER_INSTANCE;
            })
                .getSystemName(),
        ])
            .pipe(mapTo(undefined));
    }));
}
export function getItemFromSubForm(subForm) {
    if (subForm) {
        return subForm.item;
    }
}
export function loadFormMetaModel(kbData$, requiredMetaFields$, languages$, formData$, dePermission$) {
    dePermission$ = dePermission$ ? dePermission$ : of(undefined);
    return Observable.combineLatest(kbData$, requiredMetaFields$, formData$, languages$, dePermission$).pipe(first(), map(function (data) {
        var metaFields = data[0], requiredFieldIds = data[1], formData = data[2], languages = data[3], dePermission = data[4];
        var wfStateMetaField = metaFields.find(function (field) {
            return field.getType() === MetaFieldType.WORKFLOW_STATE;
        });
        return new MetaFormModel(formData.model, requiredFieldIds, metaFields, languages, wfStateMetaField, formData.type, formData.id, dePermission);
    }));
}
//# sourceMappingURL=form-helper.js.map